module.exports = __webpack_public_path__ + "img/noTempStorage.066aca28.svg";